import { HeaderContext } from '../context'
import React, { useCallback } from 'react'

interface UseProviderStickyBarHook {
  hasStickyBar: boolean
  setHasStickyBar: (value: boolean) => void
}

/**
 * Hook to manage the sticky bar state in the header.
 */
export const useStickyBar = (): UseProviderStickyBarHook => {
  const contextValue = React.useContext(HeaderContext)

  if (contextValue === undefined) {
    throw new Error('useStickyBar must be used within HeaderProvider')
  }

  const setHasStickyBar = useCallback(
    (value: boolean): void => {
      contextValue?.setHasStickyBar(value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contextValue.setHasStickyBar]
  )

  return { hasStickyBar: contextValue?.hasStickyBar, setHasStickyBar }
}
